export function slugifyColumnKey(label: string): string {
  return label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_/, '')
    .replace(/_$/, '');
}
